var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.021,
    height: 54.291,
    viewBox: "0 0 55.021 54.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.125,
    y1: 0.88,
    x2: 1.126,
    y2: 0.12,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54a5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ad3fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.022,
    y1: 0.99,
    x2: 1.022,
    y2: 0.01,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3e6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f7fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lowest-booking",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101396",
    "data-name": "Path 101396",
    d: "M-8627.951-3130.935s2.077-7.842,5.6-8.825c-.026-.082,1.941-.628,4.836,4.344.028,0,3.335,5.957-2.978,7.35,0-.028-7.541.273-7.46-2.487Z",
    transform: "translate(8648.395 3157.738)",
    fill: "#e7f4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "transfer",
    transform: "translate(24.098 21.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101543",
    "data-name": "Path 101543",
    d: "M19.016,4.49v5.634a.5.5,0,0,1-.506.49h-3a.5.5,0,0,1-.507-.49V4.49A.5.5,0,0,1,15.507,4h3a.5.5,0,0,1,.506.49Z",
    transform: "translate(-15 -3.999)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101544",
    "data-name": "Path 101544",
    d: "M22.046,7.984c0,6.024.019,5.652-.033,5.652a26.737,26.737,0,0,1-3.038-.018c0-6.022-.019-5.652.034-5.652h.674a.236.236,0,0,0,.236.236H21.1a.236.236,0,0,0,.236-.236C22.037,7.967,22.046,7.96,22.046,7.984Z",
    transform: "translate(-18.503 -7.494)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101548",
    "data-name": "Path 101548",
    d: "M4.218.035A.119.119,0,1,0,4.05.2L4.2.355H1.535A1.535,1.535,0,0,0,0,1.89a.118.118,0,0,0,.236,0,1.3,1.3,0,0,1,1.3-1.3H4.2L4.05.743a.119.119,0,0,0,.168.168C4.734.395,4.736.554,4.218.035Z",
    transform: "translate(1.563 8.261) rotate(-90)",
    fill: "#4795ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rupee-sign",
    "data-name": "Icon awesome-rupee-sign",
    d: "M1.076,2.474a.042.042,0,0,0,.042-.042v-.14a.042.042,0,0,0-.042-.042H.042A.042.042,0,0,0,0,2.292v.156a.042.042,0,0,0,.042.042h.3a.252.252,0,0,1,.213.1H.042A.042.042,0,0,0,0,2.627v.14a.042.042,0,0,0,.042.042H.6a.242.242,0,0,1-.261.2H.042A.042.042,0,0,0,0,3.056v.185a.042.042,0,0,0,.013.031L.59,3.8a.042.042,0,0,0,.028.011H.907a.042.042,0,0,0,.028-.073L.408,3.256a.479.479,0,0,0,.483-.447h.185a.042.042,0,0,0,.042-.042v-.14a.042.042,0,0,0-.042-.042H.871a.479.479,0,0,0-.05-.112Z",
    transform: "translate(1.449 -0.64)",
    fill: "#ffb369"
  })), /*#__PURE__*/React.createElement("g", {
    id: "low-price",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41275",
    "data-name": "Group 41275",
    transform: "translate(36.724 17.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122918",
    "data-name": "Path 122918",
    d: "M324.153,155.2l-8.525-8.515a.578.578,0,0,1-.09-.661.607.607,0,0,1,.562-.359h3.971v-18.65a1.241,1.241,0,0,1,1.238-1.239h6.632a1.241,1.241,0,0,1,1.238,1.239v18.65h3.971a.619.619,0,0,1,.472,1.02L325.1,155.2a.619.619,0,0,1-.944,0Z",
    transform: "translate(-315.474 -125.779)",
    fill: "#76c2fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122919",
    "data-name": "Path 122919",
    d: "M391.751,155.2l-1.05-1.048,8.491-8.48,0-.006h1.551a.619.619,0,0,1,.472,1.02l-8.525,8.515a.619.619,0,0,1-.944,0Zm2.978-29.423a1.236,1.236,0,0,1,.021.224v19.664h2.028v-18.65a1.241,1.241,0,0,0-1.238-1.239h-.81Z",
    transform: "translate(-383.072 -125.779)",
    fill: "#6ab8fe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41276",
    "data-name": "Group 41276",
    transform: "translate(10.012 16.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122920",
    "data-name": "Path 122920",
    d: "M63.179,155.765l-10.915-10.9a.74.74,0,0,1-.115-.846.778.778,0,0,1,.72-.46h5.084V119.68a1.589,1.589,0,0,1,1.586-1.586h8.491a1.589,1.589,0,0,1,1.586,1.586v23.878H74.7a.793.793,0,0,1,.6,1.306l-10.915,10.9a.793.793,0,0,1-1.209,0Z",
    transform: "translate(-52.067 -118.094)",
    fill: "#71beff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122921",
    "data-name": "Path 122921",
    d: "M153.462,155.764l-.923-.921a1.262,1.262,0,0,0,.1-.093l10.915-10.9a.8.8,0,0,0,.16-.292h1.264a.793.793,0,0,1,.6,1.306l-10.915,10.9a.793.793,0,0,1-1.209,0Zm4.3-37.671a1.575,1.575,0,0,1,.107.572v24.892H159.9V119.679a1.589,1.589,0,0,0-1.586-1.586h-.55Z",
    transform: "translate(-142.35 -118.093)",
    fill: "#6ab8fe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41277",
    "data-name": "Group 41277",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122925",
    "data-name": "Path 122925",
    d: "M15.364,0A15.364,15.364,0,1,1,0,15.364,15.364,15.364,0,0,1,15.364,0Z",
    transform: "translate(0 21.724) rotate(-45)",
    fill: "#ffb369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122922",
    "data-name": "Path 122922",
    d: "M158.907,19.681a15.364,15.364,0,0,1,0,30.727c-.33,0-.656-.012-.981-.032a15.363,15.363,0,0,0,0-30.663c.324-.02.651-.032.981-.032Z",
    transform: "translate(-137.179 -13.32)",
    fill: "#eb7f58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122926",
    "data-name": "Path 122926",
    d: "M12.088,0A12.088,12.088,0,1,1,0,12.088,12.088,12.088,0,0,1,12.088,0Z",
    transform: "translate(9.64 9.637)",
    fill: "#f5c88e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122923",
    "data-name": "Path 122923",
    d: "M60.49,51.986q.5,0,.981.04a12.088,12.088,0,0,0,0,24.1q-.485.039-.981.04a12.088,12.088,0,0,1,0-24.175Z",
    transform: "translate(-38.762 -42.349)",
    fill: "#fac279",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-rupee-sign-2",
    "data-name": "Icon awesome-rupee-sign",
    d: "M8.508,4.018a.331.331,0,0,0,.331-.331v-1.1a.331.331,0,0,0-.331-.331H.331A.331.331,0,0,0,0,2.581V3.818a.331.331,0,0,0,.331.331H2.687A1.993,1.993,0,0,1,4.371,4.9H.331A.331.331,0,0,0,0,5.233v1.1a.331.331,0,0,0,.331.331H4.717a1.909,1.909,0,0,1-2.065,1.62H.331A.331.331,0,0,0,0,8.621v1.464a.332.332,0,0,0,.107.244l4.559,4.208a.332.332,0,0,0,.225.088H7.171A.331.331,0,0,0,7.4,14.05L3.228,10.2A3.784,3.784,0,0,0,7.049,6.67H8.508a.331.331,0,0,0,.331-.331v-1.1A.331.331,0,0,0,8.508,4.9H6.887a3.784,3.784,0,0,0-.394-.884Z",
    transform: "translate(17.305 13.784)",
    fill: "#e7f4ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg2.d1be803c9ccd3278e552bd4294101e12.svg";
export { ForwardRef as ReactComponent };